<template>
    <paper class="expense-manage-mip" v-loading="loading">
        <el-form
            ref="form"
            :model="formData"
            :rules="rules"
            label-width="120px"
        >
            <el-row>
                <el-col :span="6">
                    <el-form-item label="申诉发车单总数：" prop="counts">
                        <div>{{ formData.counts }}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item label="费用未确认原因：" prop="reason">
                        <otpSelect
                            :optionNum="'NOT_CONFIRM_REASON'"
                            @getSelectValue="getSelectValue"
                            :mValue="formData.reason"
                            :multiple="true"
                            placeholder="请选择原因"
                            :prop="'reason'"
                            :disabled="!isEdit"
                        >
                        </otpSelect>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-top: 8px;">
                <el-col :span="24">
                    <el-form-item label="申诉说明：" prop="explanation">
                        <el-input
                            v-model="formData.explanation"
                            type="textarea"
                            :disabled="!isEdit"
                            maxlength="2048"
                            show-word-limit
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="button-wrapper">
            <el-upload
                class="upload-demo"
                ref="upload"
                action="upload"
                :on-error="handleError"
                :on-exceed="handleExceed"
                :before-upload="beforeUpload"
                :http-request="submitUpload"
                :auto-upload="importConfig.manualUpload"
                :multiple="importConfig.multiple"
                :show-file-list="importConfig.showFileList"
                :accept="importConfig.accept"
                :with-credentials="true"
                :file-list="fileList"
            >
                <el-button
                    size="small"
                    type="primary"
                    icon="el-icon-upload"
                    :disabled="fileList.length === 1 || !isEdit"
                    :loading="uploadBtnLoading"
                >
                    上传付款凭证</el-button
                >
            </el-upload>
            <reportExport
                #default="{ submit }"
                reportCode="DRIVER_EXPENSE_DETAIL_EXPORT"
            >
                <el-button
                    type="primary"
                    icon="el-icon-download"
                    size="mini"
                    @click="exportFile(submit)"
                >下载付款凭证上传模板</el-button>
            </reportExport>
        </div>
        <div class="file-list" v-for="(item, index) in fileList" :key="index">
            <span>{{ item.fileName }}</span>
            <el-button
                type="text"
                icon="el-icon-download"
                @click="handleDownLoad(item.path)"
            ></el-button>
            <el-button
                type="text"
                icon="el-icon-delete"
                :disabled="!isEdit"
                @click="handleDelete(index)"
            ></el-button>
        </div>
        <div class="table-wrapper">
            <span class="table-title">异常申诉发车单明细</span>
            <performance-table-box
                :config="tableConfig"
                v-loading="tableLoading"
                :tableData="tableData"
                :currentPage="searchParams.pageNo"
                :pageSize="searchParams.pageSize"
                :total="pageTotal"
                @action-click="actionClick"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></performance-table-box>
        </div>
        <el-divider></el-divider>

        <div class="btn">
            <el-button
                type="primary"
                v-if="mipUrl"
                :loading="loading"
                @click="submitMip"
            >
                MIP审批提交</el-button
            >
        </div>

        <iframe ref="frameRef" class="ifr" :src="mipUrl" v-if="mipUrl && !loading"/>
    </paper>
</template>

<script>
import paper from '@/components/core/paper/Paper';
import otpSelect from '@/components/lots/otpSelect';
import { approvalFileImport, queryAbnormalAppeal, queryAbnormalAppealDetail, appealConfirm, createProcess } from '../../../../api/driverExpenseManage.js';
import PerformanceTableBox from '../../components/PerformanceTableBox';
import { tableConfig, importConfig, verifyConfig } from './mipIframeConfig.js';
import { ossUpload } from '@/components/lots/OSS/api.js';
import { mapState } from 'vuex';
import { iflowPageURL } from '../../../../utils/iflowConf';
import reportExport from '@/components/lots/reportExportPlugin';
export default {
    name: 'DriverExpenseManageMip',
    components: { paper, PerformanceTableBox, otpSelect, reportExport },
    props: {
        params: {
            type: Object,
            default: () => { }
        }
    },
    data () {
        return {
            tableConfig,
            importConfig,
            verifyConfig,
            formData: {
                id: '',
                counts: '',
                reason: [],
                explanation: ''
            },
            rules: {
                reason: [
                    {
                        required: true,
                        message: '请选择原因',
                        trigger: ['blur', 'change']
                    }
                ],
                explanation: [
                    {
                        required: true,
                        message: '请填写申诉说明',
                        trigger: ['blur', 'change']
                    }
                ]
            },
            pageTotal: 0,
            searchParams: {
                pageNo: 1,
                pageSize: 10
            },
            uploadBtnLoading: false,
            downLoadUrl: '',
            publicRead: 1,
            bucket: 'c-tms',
            businessKey: 'default',
            contentType: 'application/octet-stream',
            fileList: [],
            requestId: '',
            iflowCode: '',
            tableData: [],
            loading: false,
            tableLoading: false,
            mipUrl: '',
            iflowStatus: '',
            createUserCode: '',
            currentPath: '/otp/transport-center/driver-expense-manage-mip'
        };
    },
    computed: {
        // 审批状态为草稿、新建、驳回 && 登录用户为流程创建者 才可以编辑
        isEdit () {
            return this.user.userCode === this.createUserCode && ['D', 'N', 'J'].includes(this.iflowStatus);
        },
        ...mapState({
            user: state => state.user,
            currentTenant: state => state.currentTenant
        })
    },
    async mounted () {
        if (this.$route.query.requestId) {
            this.requestId = this.$route.query.requestId;
            await this.init();
            window.addEventListener('message', this.messageFunc, false);
        }
    },
    async activated () {
        if (this.$route.query.requestId) {
            this.requestId = this.$route.query.requestId;
            await this.init();
            window.addEventListener('message', this.messageFunc, false);
        }
    },
    destroyed () {
        window.removeEventListener('message', this.messageFunc, false);
    },
    methods: {
        init () {
            this.loading = true;
            Promise.all([this.queryAbnormalAppeal(), this.queryAbnormalAppealDetail()])
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 申诉流程明细
        queryAbnormalAppeal () {
            queryAbnormalAppeal({ requestId: this.requestId })
                .then(res => {
                    if (res && +res.code === 0 && res.data) {
                        const { iflowStatus, iflowId, iflowCreateCode, file, id, counts, explanation, reason } = res.data;
                        this.iflowStatus = iflowStatus || '';
                        this.mipUrl = iflowId ? iflowPageURL(this.user, iflowId) : '';
                        this.createUserCode = iflowCreateCode || '';
                        this.formData.id = id || '';
                        this.formData.counts = counts || '';
                        this.formData.explanation = explanation || '';
                        this.formData.reason = reason ? reason.split(',') : [];
                        this.fileList = file ? [file] : [];
                    }
                }).catch(() => { });
        },
        // 异常申诉发车单明细
        queryAbnormalAppealDetail () {
            const params = {
                ...this.searchParams,
                param: {
                    requestId: this.requestId
                }
            };
            this.tableLoading = true;
            queryAbnormalAppealDetail(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.tableData = res.data.list || [];
                        this.pageTotal = res.data.totalCount || 0;
                    }
                })
                .catch(() => { })
                .finally(() => { this.tableLoading = false });
        },
        getSelectValue (data) {
            Object.keys(data).forEach(k => {
                this.formData[k] = data[k] || [];
            });
        },
        /**
         * @description 导出
        */
        exportFile (submit) {
            submit({
                requestId: this.requestId,
                tenantCode: this.currentTenant.tenantCode
            });
        },
        beforeUpload (file) {
            if (this.verifyConfig && this.verifyConfig.switch) {
                if (this.verifyConfig.whiteList) {
                    const fileNameSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
                    if (this.verifyConfig.whiteList.indexOf(fileNameSuffix) === -1) {
                        const msg = this.verifyConfig.whiteList + '';
                        this.$message.warning(`上传文件只能是${msg}格式`);
                        return false;
                    }
                }
                if (this.verifyConfig.fileSize) {
                    const fileSizeVerify = file.size / 1024 < this.verifyConfig.fileSize;
                    if (!fileSizeVerify) {
                        this.$message.warning(`上传文件大小不能超过${this.verifyConfig.fileSize}KB`);
                        return false;
                    }
                }
            };
            const isText = file.type === 'application/vnd.ms-excel';
            const isTextComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            return (isText | isTextComputer);
        },
        submitUpload (uploadData) {
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            this.uploadBtnLoading = true;
            const formData = new FormData();
            formData.append('file', file);
            formData.append('bucket', this.bucket);
            formData.append('businessKey', this.businessKey);
            formData.append('publicRead', this.publicRead);
            formData.append('contentType', this.contentType);
            ossUpload(formData)
                .then((res) => {
                    if (res && +res.code === 0) {
                        const downUrl = res.data.downUrl || '';
                        approvalFileImport(formData)
                            .then(res => {
                                if (res && +res.code === 0) {
                                    this.$message.success('上传成功');
                                    this.fileList.push({
                                        fileName: uploadData.file.name,
                                        path: downUrl
                                    });
                                }
                            })
                            .catch(() => { })
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.uploadBtnLoading = false;
                });
        },
        // 上传失败
        handleError () {
            this.$message.warning('上传失败');
        },
        handleExceed () {
            this.$message.warning(`超出文件上传个数限制`);
        },
        handleDownLoad (downUrl) {
            if (!downUrl) {
                return this.$message.warning('获取附件下载地址失败，刷新页面重试');
            }
            window.location = downUrl;
        },
        handleDelete (index) {
            this.fileList.splice(index, 1);
        },
        actionClick () {

        },
        handleSizeChange (pageSize) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = pageSize;
            this.queryAbnormalAppealDetail();
        },
        handleCurrentChange (pageNo) {
            this.searchParams.pageNo = pageNo;
            this.queryAbnormalAppealDetail();
        },
        submitMip () {
            if (this.isEdit) {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        if (this.fileList.length !== 1) {
                            return this.$message.warning('请上传付款凭证');
                        }
                        const params = this.getSubmitParams();
                        appealConfirm(params)
                            .then(res => {
                                if (res && +res.code === 0) {
                                    this.$refs.frameRef.contentWindow.postMessage('mbpm_getApprovalData', this.mipUrl);
                                }
                            })
                            .catch(() => { });
                    }
                });
            } else {
                this.$refs.frameRef.contentWindow.postMessage('mbpm_getApprovalData', this.mipUrl);
            }
        },
        getSubmitParams () {
            const { id, counts, explanation } = this.formData;
            return {
                id,
                counts,
                explanation,
                reason: (this.formData.reason || []).join(','),
                requestId: this.requestId,
                file: {
                    ...this.fileList[0]
                }
            };
        },
        messageFunc (event) {
            // 只有在当前页面触发，才执行相应的监听事件
            if (this.$route.path !== this.currentPath) return;
            if (event.data && event.data.data && event.data.success) {
                const params = event.data.data;
                this.loading = true;
                createProcess(params)
                    .then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('提交成功');
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.init();
                        }, 3000)
                    });
            }
        }
    }
};
</script>

<style lang="less">
.expense-manage-mip {
    .button-wrapper {
        display: flex;
        margin-top: 10px;
        .el-icon-upload,
        .el-icon-download {
            font-size: 14px;
        }
        .upload-demo {
            margin: 0px 20px 0px 10px;
        }
    }
    .table-wrapper {
        display: grid;
        .table-title {
            font-size: 14px;
            display: inline-block;
            margin: 20px 0px 0px 10px;
        }
        .table-pagination {
            display: flex;
            justify-content: end;
        }
    }
    .file-list {
        text-align: center;
        color: #00bcbf;
        font-size: 14px;
        i.el-icon-download {
            font-size: 14px;
            margin-left: 10px;
        }
        i.el-icon-delete {
            font-size: 14px;
        }
    }
    .el-form-item {
        margin-bottom: 14px;
    }
    .btn {
        margin-left: 20px;
    }
    .ifr {
        width: 100%;
        height: 110vh;
        border: none;
        margin-top: 30px;
    }
}
</style>
